module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_concept_02-e13d42a50ac1c7ac1e13d6b3c4203208.jpg";